import { Router } from '@angular/router';
import { AppConfig } from './../../app.config';
import { APIService } from 'app/services/api.service';
import { Component, Input, inject } from '@angular/core';
import { NgForm, FormsModule } from "@angular/forms";
import {AuthenticationService, authUserType} from 'app/services/auth.service';
import { LoaderService } from 'app/services/loader.service';
import { NgClass } from '@angular/common';
import { EqualValidator } from '../../components/Controls/equal-validator.directive';
import { CapsLockComponent } from '../../components/Controls/caps-lock/caps-lock.component';

type modelType = {
  existingpassword: string;
  password: string;
  confirmPassword: string;
  confirmPasswordErrorMessage: string;
  passwordErrorMessages: string[];
};

type errorType = {
  CurrentAttempt?: string;
  LockOutEndsMessage?: string;
  MaxAttempt?: string;
  UserMessage?: string;
};

@Component({
    selector: 'nwm-profile-reset-password',
    templateUrl: 'profile-reset-password.component.html',
    styleUrls: ['./profile-reset-password.component.scss'],
    imports: [FormsModule, NgClass, EqualValidator, CapsLockComponent]
})

export class ProfileResetPasswordComponent {
  private api = inject(APIService);
  config = inject(AppConfig);
  private auth = inject(AuthenticationService);
  private router = inject(Router);
  private loaderService = inject(LoaderService);

  errorMsg = '';
  successMsg = '';
  @Input()
  clientId?: number;
  isImpersonated = false;

  model: modelType = {
      existingpassword: '',
      password: '',
      confirmPassword: '',
      confirmPasswordErrorMessage: '',
      passwordErrorMessages:[]
  };
  errorType = 0;

  constructor() {
    this.isImpersonated = !!sessionStorage.getItem('guid');
  }

  submit(form: NgForm) {
    this.errorMsg='';
    this.successMsg='';
    if (this.model.existingpassword != ''
        && this.model.password != ''
        && this.model.confirmPassword != ''
    ) {
      const body = {
          'ExistingPassword': this.model.existingpassword ,
          'NewPassword': this.model.password ,
          'ConfirmPassword': this.model.confirmPassword
      };
      this.loaderService.display(true);
      this.api.post<authUserType>(this.config.resetPassword.passwordChangeUrl, body, {}).subscribe(
        successResponse => {

          form.resetForm();
          this.model.passwordErrorMessages = [];
          this.model.existingpassword = '';
          this.model.password = '';
          this.model.confirmPassword = '';

          this.successMsg = 'Thank you.  Your password has been updated.';

          this.auth.updateToken(successResponse)

          this.loaderService.display(false);
        },
        error => {
         this.handleSubmitError(error.error);
         this.loaderService.display(false);
        }
      );
    }
  }

  hasError() {
      return this.errorMsg && this.errorMsg.length > 0;
  }
  hasMessage() {
      return !this.hasError() && this.successMsg && this.successMsg.length > 0;
  }

  handleSubmitError(error: errorType) {
    if (error.UserMessage === 'Invalid login attempt.' && error.LockOutEndsMessage) {
      this.errorMsg = 'Exceeded attempt limit. Please try again after ' + error.LockOutEndsMessage + ' or go to forgot username or password.';
    } else if (error.UserMessage === 'Account lockedout.') {
      this.router.navigate(['/error/client/1']);
    }
    else if (error.UserMessage === 'Incorrect Password.') {
      this.errorType = 0;
      let msg = 'Sorry, that password is incorrect.';
      const tries = parseInt(error.MaxAttempt!) - parseInt(error.CurrentAttempt!);
      if (tries && tries > 0)
        msg = "Sorry, that password is incorrect.\nThis account will be locked after " + tries + " more attempt(s).";
      this.errorMsg = msg;
    }
    else if(error.UserMessage==='Password already in use.'){
      this.errorType = 0;
      const msg ="Sorry, this password has already been used. Please choose a different password.";
      this.errorMsg = msg;
    }
    else
    {
      this.errorType = 0;
      this.errorMsg = error.UserMessage!;
    }
  }
}
